
export default {
  name: 'ClampLines',
  props: {
    lines: { type: Number, default: 10 },
    // Line height in px for accurate clamping
    lineHeight: { type: Number, default: 22 },
    // Transition duration in ms
    duration: { type: Number, default: 250 },
    // Space reserved (px) above the button so the fade doesn’t cover it
    fadeBottomOffset: { type: Number, default: 36 }
  },
  data() {
    return {
      expanded: false,
      isOverflowing: false,
      fullHeight: 0,
      clampHeight: 0
    }
  },
  computed: {
    contentStyle() {
      const h = this.expanded ? `${this.fullHeight}px` : `${this.clampHeight}px`
      return {
        maxHeight: h,
        transition: `max-height ${this.duration}ms ease`,
        lineHeight: `${this.lineHeight}px`
      }
    },
    buttonOffset() {
      return `${this.fadeBottomOffset}px`
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.measure()
      window.addEventListener('resize', this.onResize, { passive: true })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      const prevExpanded = this.expanded
      this.expanded = true
      this.$nextTick(() => {
        this.measure()
        this.expanded = prevExpanded
      })
    },
    measure() {
      const el = this.$refs.content
      if (!el) return
      const prev = this.expanded
      this.expanded = true
      this.$nextTick(() => {
        this.fullHeight = el.scrollHeight
        this.clampHeight = Math.round(this.lines * this.lineHeight)
        this.isOverflowing = this.fullHeight > this.clampHeight + 2
        this.expanded = prev
      })
    },
    toggle() {
      if (!this.isOverflowing) return
      this.expanded = !this.expanded
      if (this.expanded) {
        this.$nextTick(() => {
          const el = this.$refs.content
          if (el) this.fullHeight = el.scrollHeight
        })
      }
    }
  }
}
